// packages/eden-list/src/components/shared.js
import { css } from "styled-components";
import { spacing8 } from "@churchofjesuschrist/eden-style-constants";
var shared = css`
  margin: 0;
  & ol,
  & ul {
    margin-block-end: ${spacing8};
  }
`;
var shared_default = shared;
export {
  shared_default as default
};
